import {
  IFlightOperatorState,
  actionTypes,
} from 'src/ducks/flight-operator.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFlightOperatorStatus = (
  state: IFlightOperatorState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
